"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
const locale = {
  assistLabel: 'You may enter:'
};
var _default = exports.default = locale;